
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Campaign page`}</h2>
    <p>{`campaigns to inform, celebrate or raise awareness`}</p>
    <ul>
      <li parentName="ul">{`short-term & ad-hoc campaigns`}</li>
      <li parentName="ul">{`limited to one specific topic`}</li>
      <li parentName="ul">{`campaigns that don't require a heavy amount of content – e.g. image driven campaigns`}</li>
      <li parentName="ul">{`campaigns that convey brief facts, figures and testimonials`}</li>
      <li parentName="ul">{`basic campaigns`}</li>
    </ul>
    <h2>{`Basic features`}</h2>
    <p>{`You don't need to use all the listed components. You can choose fromhe below, depending on the user's need.`}</p>
    <ul>
      <li parentName="ul">{`Text`}</li>
      <li parentName="ul">{`Page banner (smaller, for promotional or homepage use only)`}</li>
      <li parentName="ul">{`Hero (bigger, for promotional use only)`}</li>
      <li parentName="ul">{`Testimonials/blockquotes`}</li>
      <li parentName="ul">{`Media container`}</li>
      <li parentName="ul">{`Gallery`}</li>
      <li parentName="ul">{`Events`}</li>
      <li parentName="ul">{`News`}</li>
      <li parentName="ul">{`Social media sharing`}</li>
    </ul>
    <h2>{`Campaign minisite`}</h2>
    <ul>
      <li parentName="ul">{`Promotion/involving & debating campaigns`}</li>
      <li parentName="ul">{`Long-term campaigns`}</li>
      <li parentName="ul">{`Inter-institutional level campaigns`}</li>
      <li parentName="ul">{`Campaigns that have their own branding`}</li>
      <li parentName="ul">{`Campaigns that have a clear "call to action" – (e.g. participating in a contest)`}</li>
      <li parentName="ul">{`Campaigns that encourage specific user actions (e.g. signing up, subscribing – registration form, data collection etc.)`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;